export const acceptAction = 'transition/accept';
export const enquireAction = 'transition/enquire';
export const requestAction = 'transition/request-payment';
export const declineAction = 'transition/decline-by-provider';
export const newMessageAction = 'NEW_MESSAGE';
export const messageOpenedByCustomerEventType = 'messageOpenedByCustomerEventType';
export const messageOpenedByProviderEventType = 'messageOpenedByProviderEventType';
export const bookingOpenedByCustomerEventType = 'bookingOpenedByCustomerEventType';
export const bookingOpenedByProviderEventType = 'bookingOpenedByProviderEventType';

export const bookingProposalRequestEventType = 'transition/proposal';
export const bookingProposalAcceptedEventType = 'transition/proposal-accept';
export const bookingProposalDeclinedEventType = 'transition/proposal-decline';
export const bookingCounterProposalEventType = 'transition/counter-proposal';
export const bookingCounterProposalAcceptedEventType = 'transition/counter-proposal-accept';
export const bookingCounterProposalDeclinedEventType = 'transition/counter-proposal-decline';
export const bookingAskForProposalFromProviderEventType = 'askForProposalFromProviderEventType';
